import axios from "../utils/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { clearClientStorage } from "../utils/sessionManager";

export const signUp = createAsyncThunk(
  "auth/signup",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("auth/signup", payload);
      if (response) {
        return response?.data;
      }
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  },
);
// ---
export const socialLogin = createAsyncThunk(
  "auth/socialLogin",
  async (payload, thunkAPI) => {
    try {
      // payload: { provider: "facebook" | "Google" | "Apple", token: string }
      const response = await axios.post("auth/socialLogin", payload);
      if (response) {
        return response?.data;
      }
    } catch (error) {
      // Normalize error to a message the UI can show
      const message =
        error?.response?.data ||
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";
      return thunkAPI?.rejectWithValue(message);
    }
  },
);
// ---
export const login = createAsyncThunk(
  "auth/login",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("auth/login", payload);
      if (response) {
        return response?.data;
      }
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  },
);
// ---
export const forgetPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("auth/forgotPassword", payload);
      return response?.data;
    } catch (error) {
      // Normalize error so UI doesn't receive a raw object like [object Object]
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";
      return thunkAPI?.rejectWithValue(message);
    }
  },
);
// ---
export const emailVerification = createAsyncThunk(
  "auth/emailVerification",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("auth/emailVerification", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  },
);
// ---
export const getAccessToken = async (payload) => {
  try {
    const response = await axios.post("auth/refresh", payload);
    return response?.data;
  } catch (error) {
    throw error;
  }
};
// ---
export const otpVerification = createAsyncThunk(
  "auth/verifyForgotOtp",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("auth/verifyForgotOtp", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  },
);

// ---
export const sendSignupOtp = createAsyncThunk(
  "auth/sendSignupOtp",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("auth/sendSignupOtp", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(
        error?.data ||
          error?.response?.data || {
            success: false,
            message: error?.message || "Failed to send OTP",
          },
      );
    }
  },
);

// ---
export const verifySignupOtp = createAsyncThunk(
  "auth/verifySignupOtp",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("auth/verifySignupOtp", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  },
);

export const saveMemberSignupDraft = createAsyncThunk(
  "auth/saveMemberSignupDraft",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("auth/memberSignupDraft", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  },
);
// ---
export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("auth/resetPassword", payload);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  },
);
// ---
export const updatePassword = createAsyncThunk(
  "auth/updatePassword",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.put("profile/updatePassword", payload);
      return {
        status: response?.status, // e.g., 200 or 400
        message: response?.data?.message, // the only thing your backend sends
      };
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Something went wrong",
      });
    }
  },
);

// ---
export const logout = createAsyncThunk(
  "auth/logout",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post("auth/logout", payload);
      if (response) {
        localStorage.removeItem("swoodle_selected_merchant_id");
        clearClientStorage();
        return response?.data;
      }
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  },
);
